import styled from 'styled-components'

export const AppLayout = styled.main`
  max-width: 450px;
  margin: 0 auto;
`
